

const Button = ({ label, iconURL }) => {
  return (
    <button className="flex justify-center items-center gap-2 py-5 px-6 border font-montserrat text-lg leading-none bg-coral-red rounded-full text-white border-coral-red ">

      {label}
      {iconURL && < img src={iconURL} alt="Arrow right icon " className="ml-2 rounded-full w-5 h-5" />}
    </button>
  )
}

export default Button;